import type { PatchRelease } from "../types";
import { releaseSortKey } from "../types";
import { release as r20260630_01 } from "./2026-06-30_01";
import { release as r20260627_01 } from "./2026-06-27_01";
import { release as r20260626_02 } from "./2026-06-26_02";
import { release as r20260626_01 } from "./2026-06-26_01";
import { release as r20260624_01 } from "./2026-06-24_01";
import { release as r20260622_01 } from "./2026-06-22_01";
import { release as r20260611_01 } from "./2026-06-11_01";
import { release as r20260610_01 } from "./2026-06-10_01";
import { release as r20260607_02 } from "./2026-06-07_02";
import { release as r20260607_01 } from "./2026-06-07_01";
import { release as r20260606_01 } from "./2026-06-06_01";
import { release as r20260605_01 } from "./2026-06-05_01";
import { release as r20260604_01 } from "./2026-06-04_01";
import { release as r20260603_01 } from "./2026-06-03_01";
import { release as r20260602_01 } from "./2026-06-02_01";
import { release as r20260601_01 } from "./2026-06-01_01";

/** Register every release file here (order does not matter — sorted newest first). */
const ALL_RELEASES: PatchRelease[] = [
  r20260630_01,
  r20260627_01,
  r20260626_02,
  r20260626_01,
  r20260624_01,
  r20260622_01,
  r20260611_01,
  r20260610_01,
  r20260607_02,
  r20260607_01,
  r20260606_01,
  r20260605_01,
  r20260604_01,
  r20260603_01,
  r20260602_01,
  r20260601_01,
];

export const PATCH_RELEASES: PatchRelease[] = [...ALL_RELEASES].sort(
  (a, b) => releaseSortKey(b.id).localeCompare(releaseSortKey(a.id)),
);
